const btnStyle = {
  backgroundColor: "#fff",
  borderRadius: "3px",
  height: "26px",
  padding: "0",
  fontSize: "12px",
};

export const donebtnStyle = {
  ...btnStyle,
  fontFamily: "DM Sans",
  border: "1px solid #196fe0",
  color: "#196fe0",
  width: "54px",
  margin: "17px 17px auto 16px",
  hover: `{
      background: #196fe0 !important;
      border-color: #196fe0;
      boxShadow:
      0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);
      color: #fff !important;;
    }`,
};

export const cancelBtnStyle = {
  ...btnStyle,
  color: "#97a3b7",
  margin: "17px 0px",
  border: "1px solid #fff",
  fontFamily: "DM Sans",
  width: "64px",
  hover: `{
      background: rgb(236, 239, 246) !important;
      border-color: rgb(236, 239, 246) !important;
    }`,
};

export const iconStyles = {
  status: {
    marginBottom: "-4px",
  },
  assigned_to: {
    marginBottom: "0px",
  },
};

export const tagsDropdownRadioSelectWrapperStyles = {
  padding: "4px 15px 14px 18px",
  boxShadow: "0 -1px 1px 0 rgba(0, 0, 0, 0.08)",
};
